import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoaderComponent } from '../../../../shared/components/button-loader/button-loader.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { UploadImageComponent } from '../../../../shared/components/upload-image/upload-image.component';
import { MediaSignedUrlModel } from '../../../../shared/interface/interface';
import { TopicModel } from '../../../../shared/models/faq.model';
import { FaqService } from '../../../../shared/services/faq.service';
import { SharedModule } from '../../../../shared/shared.module';
import { InputWrapperComponent } from '../../../../shared/components/input-wrapper/input-wrapper.component';

@Component({
  selector: 'app-add-edit-topic',
  standalone: true,
  templateUrl: './add-edit-topic.component.html',
  styleUrl: './add-edit-topic.component.scss',
  imports: [
    UploadImageComponent,
    SharedModule,
    ButtonComponent,
    ButtonLoaderComponent,
    InputWrapperComponent,
  ],
})
export class AddEditTopicComponent implements OnInit {
  @Input() topic: TopicModel | null = null;
  @Output() onClose = new EventEmitter();
  @Output() onComplete = new EventEmitter();
  imageUrl = '';
  imageUploading = false;
  topicForm: FormGroup = this.fb.group({
    name: ['', [Validators.required]],
    img: ['', [Validators.required]],
  });
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private faqService: FaqService,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.topicForm.setValue({
      img: this.topic?.imgKey || '',
      name: this.topic?.name || '',
    });
    this.imageUrl = this.topic?.img || '';
  }

  onUploadStart() {
    this.imageUploading = true;
  }
  onUploadEnd(data: MediaSignedUrlModel | null) {
    this.imageUploading = false;
    if (data) {
      this.topicForm.get('img')?.setValue(data.key);
      this.imageUrl = data.contentUrl;
    }
  }
  onSubmit() {
    if (this.topicForm.invalid || this.imageUploading) {
      this.topicForm.markAllAsTouched();
      return;
    }
    const { name, img } = this.topicForm.value;
    this.isLoading = true;
    if (this.topic) {
      this.faqService.updateTopic(this.topic.id, { name, img }).subscribe({
        next: (res) => {
          this.toastr.success('Topic updated successfully!');
          this.isLoading = false;
          this.onComplete.emit();
        },
        error: (err) => {
          this.toastr.error(
            err?.error?.message || err?.message || 'Something went wrong!'
          );
          this.isLoading = false;
        },
      });
    } else {
      this.faqService.addTopic({ name, img }).subscribe({
        next: (res) => {
          this.toastr.success('Topic added successfully!');
          this.isLoading = false;
          this.onComplete.emit();
        },
        error: (err) => {
          this.toastr.error(
            err?.error?.message || err?.message || 'Something went wrong!'
          );
          this.isLoading = false;
        },
      });
    }
  }

  handleClose() {
    this.onClose.emit();
  }

  removeImage() {
    this.imageUrl = '';
    this.topicForm.get('img')?.setValue('');
  }
}
